{
  "title": "Алтай на автодоме",
  "subtitle": "Пять дней среди рек, перевалов и бесконечной дороги",
  "dates": "12–16 июля 2026",
  "intro": "От Чемальского тракта до Курайской степи — семейное путешествие по одной из самых красивых дорог России.",
  "finish": "Пять дней, сотни поворотов и Алтай, к которому хочется вернуться.",
  "heroPhotoId": "img_5226",
  "photoAutoAssignThresholdKm": 35
}
